import INavBar from '@src/component/INavBar'
import VerticalSpace from '@src/component/VerticalSpace'
import { replaceTo } from '@src/route'
import CommonService from '@src/service/commonService'
import { getUrlParams } from '@src/util'
import { ImageViewer, Space } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import './index.scss'

interface DetailProps {
  imgUrls: { [key: string]: AfterUploadProps[] }
  [key: string]: any
}

function ApplicationDetail(props: any) {
  const {
    location: { search },
  } = props
  const params = getUrlParams(search)
  const [detail, setDetail] = useState<DetailProps>({} as DetailProps)

  useEffect(() => {
    CommonService.getApplyDetail({ loaninginfoId: params.id }).then(
      (res: any) => {
        console.log(res)
        if (res) {
          setDetail(res)
        } else {
          setDetail({} as DetailProps)
        }
      }
    )
  }, [])

  const submit = () => {
    if (params.status === '3') {
      replaceTo('/apply-detail-edit', {
        id: params.id,
        name: params.name,
        status: params.status,
        source: params.source,
      })
    }
  }

  return (
    <div className="apply-page">
      <INavBar title={`${params.name}的放款申请 `} />
      {detail.jujueReason && (
        <div className="reason">
          <span>
            {params.status === '3' && '已驳货:驳回'}
            {params.status === '4' && '已拒绝:拒绝'}
            原因：
          </span>
          {detail.jujueReason}
        </div>
      )}

      <div className="wrapper">
        <VerticalSpace size={16}>
          <ImageUpload
            labelText="购车合同"
            value={detail?.imgUrls?.carpurcontract}
          />
          <ImageUpload
            required
            labelText="购车发票"
            value={detail?.imgUrls?.carpurinvoice}
          />
          {/* <ImageUpload
            required
            labelText="驾驶证正本"
            value={detail?.imgUrls?.driverlicoriginal}
          />
          <ImageUpload
            required
            labelText="驾驶证副本"
            value={detail?.imgUrls?.driverliccopy}
          /> */}
          {detail?.imgUrls?.firstPaidProof?.length > 0 && (
            <ImageUpload labelText="首付款支付凭证" value={detail?.imgUrls?.firstPaidProof} />
          )}
          {detail?.imgUrls?.carlic?.length > 0 && (
            <ImageUpload labelText="行驶证" value={detail?.imgUrls?.carlic} />
          )}

          {detail?.imgUrls?.carreglic?.length > 0 && (
            <ImageUpload
              labelText="登记证"
              value={detail?.imgUrls?.carreglic}
            />
          )}
          {detail?.imgUrls?.earnestmoneypaidproof?.length > 0 && (
            <ImageUpload
              labelText="保证金付款凭证"
              value={detail?.imgUrls?.earnestmoneypaidproof}
            />
          )}
          {detail?.imgUrls?.commissionpaidproof?.length > 0 && (
            <ImageUpload
              labelText="手续费付款凭证"
              value={detail?.imgUrls?.commissionpaidproof}
            />
          )}
          {detail?.imgUrls?.mortgageagencyfeepaymentvoucher?.length > 0 && (
            <ImageUpload
              labelText="抵押代办费付款凭证"
              value={detail?.imgUrls?.mortgageagencyfeepaymentvoucher}
            />
          )}
          {detail?.imgUrls?.securityservicepaidproof?.length && (
            <ImageUpload
              labelText="盗抢保障订单截图凭证"
              value={detail?.imgUrls?.securityservicepaidproof}
            />
          )}
          {detail?.imgUrls?.rideaccidentservicepaidproof?.length > 0 && (
            <ImageUpload
              labelText="骑行意外险付款截图"
              value={detail?.imgUrls?.rideaccidentservicepaidproof}
            />
          )}
          {detail?.imgUrls?.peopleAndCarsProof?.length > 0 && (
            <ImageUpload
              labelText="人车合影照"
              value={detail?.imgUrls?.peopleAndCarsProof}
            />
          )}
          {detail?.imgUrls?.engineProof?.length > 0 && (
            <ImageUpload
              labelText="发动机照"
              value={detail?.imgUrls?.engineProof}
            />
          )}
          {detail?.imgUrls?.carframeProof?.length > 0 && (
            <ImageUpload
              labelText="车架照"
              value={detail?.imgUrls?.carframeProof}
            />
          )}
          {detail?.imgUrls?.personalaccidentservicepaidproof?.length > 0 && (
            <ImageUpload
              labelText="其他"
              value={detail?.imgUrls?.personalaccidentservicepaidproof}
            />
          )}
        </VerticalSpace>
      </div>

      {['1', '2', '3', '4'].includes(params.status) && (
        <div className="btn" onClick={submit}>
          {params.status === '1' && '待审核'}
          {params.status === '2' && `已通过，放款`}
          {params.status === '3' && '已驳回,重新编辑提交'}
          {params.status === '4' && '已拒绝'}
        </div>
      )}
    </div>
  )
}

interface AfterUploadProps {
  id: number
  osskey: string
  osskeySmall: string
}
interface ImageUploadProps {
  required?: boolean
  labelText: string
  value?: AfterUploadProps[]
}
function ImageUpload({ required = false, labelText, value }: ImageUploadProps) {
  const [fileList, setFileList] = useState<AfterUploadProps[]>([])
  const [fileListString, setFileListString] = useState<string[]>([])
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (value && value.length > 0) {
      setFileList(value)
      setFileListString(value.map((item) => item.osskey))
    }
  }, [value])

  return (
    <>
      <ImageViewer.Multi
        images={fileListString}
        visible={visible}
        defaultIndex={0}
        onClose={() => {
          setVisible(false)
        }}
      />
      <div className="upload-page">
        <Space align="center" style={{ '--gap': '2px' }}>
          {required && <span className="required">*</span>}
          <span className="label-text">{labelText}：</span>
        </Space>
        <div className="img-box">
          <Space style={{ '--gap': '12px' }} align="center" wrap>
            {fileList.length > 0 &&
              fileList.map((item) => (
                <div key={item.id}>
                  <img
                    src={item.osskey}
                    alt=""
                    onClick={() => setVisible(true)}
                  />
                </div>
              ))}
          </Space>
        </div>
      </div>
    </>
  )
}
export default ApplicationDetail
